<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheHeader />
    <!-- <TheSidebar /> -->

    <div
      class="c-wrapper"
    >
          <!-- <div
      class="c-wrapper"
      :class="{ 'sidebar-open': $store.state.sidebarShow }"
    > -->
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </div>

    <CenterLoading />
  </div>
</template>


<script>
// import TheSidebar from './Usidebar'
import TheHeader from './Uheader'
import TheFooter from '../TheFooter'
import { mapActions } from "vuex";

export default {
  name: 'TheContainer',
  components: {

    // TheSidebar,
    TheHeader,
    TheFooter,
  },

  mounted() {
    // โหลดข้อมูลผู้ใช้หลัง login
    this.loadUserProfile();
  },

  methods: {
    ...mapActions("user", ["getProfile"]),

    async loadUserProfile() {
      try {
        await this.getProfile(); // เรียก Vuex
      } catch (err) {
        console.error("Load profile error:", err);
      }
    },
  },
};
</script>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}










.c-wrapper {
  transition: margin-left 0.3s ease;
  margin-left: 0;
}

/* ปรับขนาดเท่ากับ sidebar */
.sidebar-open {
  margin-left: 250px; /* ความกว้าง sidebar ของคุณ */
}
.sidebar-minimized {
  margin-left: 80px; /* กว้างตอน minimize */
}
/* เลื่อน body ลงมาใต้ header */

.c-body {
  padding-top: 66px; /* ความสูงของ CHeader */
}

</style>